import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Camera, ConfigCamera, CameraPost } from '@classes/camera/camera';
import { Slots } from '@classes/slots/slots';
import { faChevronLeft, faSearch, faPlus, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { CamerasService } from '@services/cameras/cameras.service';
import { SlotsService } from '@services/slots/slots.service';
import { SmartparkingSlotsAddComponent } from '../smartparking-slots-add/smartparking-slots-add.component';

@Component({
  selector: 'app-smartparking-cameras-update',
  templateUrl: './smartparking-cameras-update.component.html',
  styleUrls: ['./smartparking-cameras-update.component.scss']
})
export class SmartparkingCamerasUpdateComponent implements OnInit {

  faChevronLeft = faChevronLeft;
  faSearch = faSearch;
  faPlus = faPlus;
  faSyncAlt = faSyncAlt;

  show = false;

  idCamera: any;
  nameCamera: any;
  camera: Camera;

  inactive = true;
  arrayInputValueCamera: string[] = [];

  updateCameraForm: UntypedFormGroup;
  valideForm = true;
  updateFormLoading = false;
  configCam: ConfigCamera;

  cameraMode = false;
  cameraReset = false;

  displayedColumnsAdmin: string[] = ['name', 'status', 'statusTime', 'timeLimitExceeded'];
  dataSource: MatTableDataSource<Slots>;

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';


  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;


  constructor(
    private route: ActivatedRoute,
    private cameraService: CamerasService,
    private formBuilder: UntypedFormBuilder,
    private slotsService: SlotsService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getQueryParams();
    this.initForm();
    // this.getSlotsCamera();

  }

  onSubmit(): void {
    this.updateFormLoading = true;
    this.valideForm = true;
    const updateCamera: CameraPost = {
      id: this.idCamera,
      name: this.updateCameraForm.get('name').value,
      ip: this.updateCameraForm.get('ip').value,
      port: this.updateCameraForm.get('port').value,
      syncTime: this.updateCameraForm.get('syncTime').value
    };
    this.inactive = true;

    this.cameraService.updateCamera(updateCamera).subscribe(() => {
      this.getInfosCamera();
      setTimeout(() => {
        this.updateFormLoading = false;
      }, 250);
    });
  }

  applyFilter(filterValue): void {
    this.slotsService.keyword.next(filterValue);
  }

  getTitlePage(title: string): void {
    this.nameCamera = title;
  }

  isInactive(valueInput: any): void {
    const existInArrayInputValueCamera = this.arrayInputValueCamera.find(item => item === valueInput.toString());
    const inputs = Array.from(document.querySelectorAll('input'));
    const regex = /^-?(0|[1-9]\d*)?$/;

    inputs.forEach((input, index) => {
      if (!input.classList.contains('input_form_updateCameraForm')) {
        inputs.splice(index, 1);
      }
      inputs.forEach((i, iIndex) => {
        if (i.type === 'checkbox') {
          inputs.splice(iIndex, 1);
        }
      });
    });

    existInArrayInputValueCamera ?
      this.inactive = true :
      !valueInput || valueInput < 1 ?
        this.inactive = true :
        this.updateCameraForm.invalid ? this.inactive = true : this.inactive = false;
  }

  isZero(valueInput: any) {
    valueInput > 0 ? this.inactive = false : this.inactive = true;
  }

  updateConfigCamera(): void {
    const config: ConfigCamera = {
      mode: this.cameraMode === true ? 'Prod' : 'Démo',
      reset: this.cameraReset
    };
    this.cameraService.updateConfigCamera(this.idCamera, config).subscribe(() => { });
  }

  opDialogAddSlot(): void {
    const dialogRef = this.dialog.open(SmartparkingSlotsAddComponent, {
      data: {
        cameraId: this.idCamera
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      // this.getSlotsCamera();
    });
  }

  showElement(): void {
    setTimeout(() => {
      this.show = true;
    }, 250);
  }

  goBack(): void {
    const name = this.route.snapshot.queryParams.name;
    const id = this.route.snapshot.queryParams.id;
    const ip = this.route.snapshot.queryParams.ip;

    const params = { name, id, ip };

    this.router.navigate(['/smartparking/slots'], { queryParams: params });
  }

  private getQueryParams(): void {
    this.idCamera = this.route.snapshot.queryParams.id;
    this.nameCamera = this.route.snapshot.queryParams.name;
    this.getInfosCamera();
    this.getConfigCamera();
  }

  private getInfosCamera(): void {
    this.arrayInputValueCamera = [];
    this.cameraService.getCameras().subscribe(res => {
      this.camera = res.find(camera => camera.id === this.idCamera);
      this.nameCamera = this.camera.name;
      this.updateCameraForm.get('name').setValue(this.camera.name);
      this.updateCameraForm.get('ip').setValue(this.camera.ip);
      this.updateCameraForm.get('port').setValue(this.camera.port);
      this.updateCameraForm.get('syncTime').setValue(this.camera.syncTime);
      this.arrayInputValueCamera.push(this.camera.name, this.camera.ip, this.camera.port.toString(), this.camera.syncTime.toString());
    });
  }

  private getConfigCamera(): void {
    this.cameraService.getConfigCamera(this.idCamera).subscribe(res => {
      this.configCam = res;
      res.mode === 'Prod' ? this.cameraMode = true : this.cameraMode = false;
      this.cameraReset = res.reset;
    });
  }

  private initForm(): void {
    this.updateCameraForm = this.formBuilder.group({
      name: ['', Validators.required],
      ip: ['', Validators.required],
      port: ['', [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      syncTime: ['', [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      timeExceeded: ['']
    });
  }


}
